/**
 * The type of (redux) action which signals that a custom notification component should
 * be displayed.
 *
 * {
 *     type: SHOW_CUSTOM_NOTIFICATION,
 *     component: ReactComponent,
 *     props: Object,
 * }
 */
export const SHOW_CUSTOM_NOTIFICATION = 'SHOW_CUSTOM_NOTIFICATION';

/**
 * The type of (redux) action which signals that a custom notification component should
 * be not displayed.
 *
 * {
 *     type: HIDE_CUSTOM_NOTIFICATION
 * }
 */
export const HIDE_CUSTOM_NOTIFICATION = 'HIDE_CUSTOM_NOTIFICATION';